import {
  isLatLng,
  isSatellitePlace,
  isSearchAddressResult,
} from 'utils/typeGuards';

export const getLocationLatLon = (location: any) => {
  if (isSatellitePlace(location)) {
    return location.destination_geo;
  }
  if (isLatLng(location)) {
    return {
      lat: location.lat,
      lon: location.lng,
    };
  }
  if (isSearchAddressResult(location)) {
    return location.geolocation;
  }
};

export default getLocationLatLon;
